const NAMESPACE = '@@loading';
function shouldEffect({ type }, includes, excludes) {
  if (includes.length === 0 && excludes.length === 0) {
    return true;
  }

  if (includes.length > 0) {
    return includes.indexOf(type) > -1;
  }

  return excludes.length > 0 && excludes.indexOf(type) === -1;
}
const createLoadingPlugin = ({
  namespace = NAMESPACE,
  includes = [],
  excludes = [],
} = {}) => (store) => {
  if (store.state[namespace]) {
    throw new Error(
      `createLoadingPlugin: ${namespace} exited in current store`,
    );
  }

  store.registerModule(namespace, {
    namespaced: true,
    state: {
      global: false,
      effects: {

      },
    },
    mutations: {
      SHOW(state, { payload }) {
        state.global = true;
        state.effects = {
          ...state.effects,
          [payload]: true,
        };
      },
      HIDE(state, { payload }) {
        state.global = false;
        state.effects = {
          ...state.effects,
          [payload]: false,
        };
      },
    },
  });

  store.subscribeAction({
    before: (action) => {
      if (shouldEffect(action, includes, excludes)) {
        store.commit({ type: `${namespace}/SHOW`, payload: action.type });
      }
    },
    after: (action) => {
      if (shouldEffect(action, includes, excludes)) {
        store.commit({ type: `${namespace}/HIDE`, payload: action.type });
      }
    },
  });
};

export default createLoadingPlugin;
